<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../../helpers/interface_helpers';
	import { getErrorOrInfoMessageForMinAndMax } from '../../../../../helpers/utilities';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	//Services
	import { postReq } from '../../../../../services/http';
	//Stores
		//Design system components
	import { Text, Input } from '@Shelly/shelly-design-system';
	//Types
	import type { Request } from '../../../../../types/requests/request';
	import type { Device } from '../../../../../types/Device';

	$: settingsStore = getDeviceSettings(id);
	export let disabled: boolean;
	export let device: Device;
	export let error = false;
	export const save = async (): Promise<Request> => {
		if (value == settings.pulse_count) return { isok: true };
		return await postReq(
			`/device/generic_command`,
			{
				id,
				command: `motion_pulse_count`,
				payload: JSON.stringify({ value: Number(value) }),
			},
			10000,
		);
	};

	const id = real_id(device.id),
		settings = $settingsStore.motion,
		min = 1,
		max = 4;

	let value = settings.pulse_count;

	$: inputData = getErrorOrInfoMessageForMinAndMax(value, min, max);
	$: error = !!inputData.error;
</script>

<Text
	styleType="body-small"
	class={classMap({
		'mb-xs': true,
		'text-color-3': disabled,
	})}
>
	{$format('motion_pulse_count_message', {
		default: `Number of consecutive movements to report motion.`,
	})}
</Text>

<Input
	icon="fas fa-person-walking"
	class="mb-m"
	bind:value
	{disabled}
	info={inputData.info}
	error={!disabled ? inputData.error : ''}
	type="number"
	step={1}
	id="input-d1qzrgb"
	aria-label={$format('motion_pulse_count_message', {
		default: `Number of consecutive movements to report motion.`,
	})}
/>
